export default "__VITE_ASSET__BeHCaJJh__"